import $ from 'jquery';

import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js';
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker';

export default function(controller) {

  // Bootstrap 5 makes form wrappers `position: static`, but this (Bootstrap 3-era)
  // datetimepicker throws unless it can find a non-static positioned ancestor to
  // anchor its popup to. Ensure the immediate wrapper is positioned before init.
  $("[data-toggle='datetimepicker-default']").each(function () {
    $(this).closest('.input, .form-group, [class*="col-"]').css('position', 'relative');
  });

  $("[data-toggle='datetimepicker-default']").datetimepicker({
    format: 'DD/MM/YYYY, hh:mm a',
    collapse: false,
  });

};
